import { render, staticRenderFns } from "./bobaoqi.vue?vue&type=template&id=3c55a0f2&scoped=true&"
import script from "./bobaoqi.vue?vue&type=script&lang=js&"
export * from "./bobaoqi.vue?vue&type=script&lang=js&"
import style0 from "./bobaoqi.vue?vue&type=style&index=0&id=3c55a0f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c55a0f2",
  null
  
)

export default component.exports